import { render, staticRenderFns } from "./NewPwdView.vue?vue&type=template&id=50341a06&scoped=true&"
import script from "./NewPwdView.vue?vue&type=script&lang=js&"
export * from "./NewPwdView.vue?vue&type=script&lang=js&"
import style0 from "./NewPwdView.vue?vue&type=style&index=0&id=50341a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50341a06",
  null
  
)

export default component.exports